"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberDenyStatusSchema = void 0;
var zod_1 = require("zod");
exports.MemberDenyStatusSchema = zod_1.z.object({
    denied: zod_1.z.boolean(),
    maxAttemptCount: zod_1.z.string().nullish(),
});
